// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { epochToYYYYMMDD } from 'helpers/timeConversion'

const prepData = arr => arr.map((d, i) => {
  d.createTime = epochToYYYYMMDD(d.createTimestamp) || 'n/a'
  d.modifiedTime = epochToYYYYMMDD(d.lastModifiedTimestamp) || 'n/a'
  d.projectIndex = i + 1
  d.uniqueId = 'projectId' //  for DataTable to have a unique id.
  return d
})

export default prepData
